import { lazy } from 'react';

/** Central lazy imports for route-based code splitting. */

// System
export const LoginPage = lazy(() => import('@/routes/pages/LoginPage'));
export const RegisterPage = lazy(() => import('@/routes/pages/RegisterPage'));
export const ForgotPasswordPage = lazy(() => import('@/routes/pages/ForgotPasswordPage'));
export const InviteAcceptPage = lazy(() => import('@/routes/pages/InviteAcceptPage'));
export const ForbiddenPage = lazy(() => import('@/routes/pages/ForbiddenPage'));
export const NotFoundPage = lazy(() => import('@/routes/pages/NotFoundPage'));
export const RouteErrorPage = lazy(() => import('@/routes/pages/RouteErrorPage'));

// Dashboard
export const DashboardPage = lazy(() => import('@/features/dashboard/pages/DashboardPage'));
export const ConfigurePage = lazy(() => import('@/features/configure/pages/ConfigurePage'));

// Salesforce
export const SalesforceOrgListPage = lazy(
  () => import('@/features/salesforce/pages/SalesforceOrgListPage')
);
export const OrgOverviewTab = lazy(
  () => import('@/features/salesforce/pages/org-hub/OrgOverviewTab')
);
export const OrgAuthenticationTab = lazy(
  () => import('@/features/salesforce/pages/org-hub/OrgAuthenticationTab')
);
export const OrgRoutingTab = lazy(
  () => import('@/features/salesforce/pages/org-hub/OrgRoutingTab')
);
export const OrgTelephonyTab = lazy(
  () => import('@/features/salesforce/pages/org-hub/OrgTelephonyTab')
);
export const OrgAgentsTab = lazy(
  () => import('@/features/salesforce/pages/org-hub/OrgAgentsTab')
);

// Telephony
export const TelephonyConnectionListPage = lazy(
  () => import('@/features/telephony/pages/TelephonyConnectionListPage')
);
export const PhoneNumberListPage = lazy(
  () => import('@/features/telephony/pages/PhoneNumberListPage')
);
export const ConnectionOverviewTab = lazy(
  () => import('@/features/telephony/pages/connection-hub/ConnectionOverviewTab')
);
export const ConnectionConfigTab = lazy(
  () => import('@/features/telephony/pages/connection-hub/ConnectionConfigTab')
);
export const ConnectionNumbersTab = lazy(
  () => import('@/features/telephony/pages/connection-hub/ConnectionNumbersTab')
);
export const ConnectionWebhooksTab = lazy(
  () => import('@/features/telephony/pages/connection-hub/ConnectionWebhooksTab')
);

// Operations
export const ValidationCenterPage = lazy(
  () => import('@/features/validation/pages/ValidationCenterPage')
);
export const HealthCenterPage = lazy(() => import('@/features/health/pages/HealthCenterPage'));
export const CallListPage = lazy(() => import('@/features/calls/pages/CallListPage'));
export const CallDetailPage = lazy(() => import('@/features/calls/pages/CallDetailPage'));
export const AuditLogPage = lazy(() => import('@/features/audit/pages/AuditLogPage'));
export const LoginHistoryPage = lazy(
  () => import('@/features/audit/pages/LoginHistoryPage')
);

// Users (portal Agents)
export const PortalUserListPage = lazy(() => import('@/features/users/pages/PortalUserListPage'));
export const PortalUserDetailPage = lazy(
  () => import('@/features/users/pages/PortalUserDetailPage')
);

// Settings
export const SettingsAccountPage = lazy(
  () => import('@/features/settings/pages/SettingsAccountPage')
);
export const SettingsOrganizationPage = lazy(
  () => import('@/features/settings/pages/SettingsOrganizationPage')
);
export const SettingsSecurityPage = lazy(
  () => import('@/features/settings/pages/SettingsSecurityPage')
);
export const SettingsCredentialsPage = lazy(
  () => import('@/features/settings/pages/SettingsCredentialsPage')
);
export const CredentialDetailPage = lazy(
  () => import('@/features/settings/pages/CredentialDetailPage')
);
export const SettingsNotificationsPage = lazy(
  () => import('@/features/settings/pages/SettingsNotificationsPage')
);

// Platform
export const PlatformDashboardPage = lazy(
  () => import('@/features/platform/pages/PlatformDashboardPage')
);
export const PlatformTenantListPage = lazy(
  () => import('@/features/platform/pages/PlatformTenantListPage')
);
export const PlatformTenantDetailPage = lazy(
  () => import('@/features/platform/pages/PlatformTenantDetailPage')
);
export const PlatformInventoryPage = lazy(
  () => import('@/features/platform/pages/PlatformInventoryPage')
);
export const PlatformProviderCatalogPage = lazy(
  () => import('@/features/platform/pages/PlatformProviderCatalogPage')
);
export const PlatformSystemHealthPage = lazy(
  () => import('@/features/platform/pages/PlatformSystemHealthPage')
);
export const PlatformAuditPage = lazy(
  () => import('@/features/platform/pages/PlatformAuditPage')
);
